import { render, staticRenderFns } from "./RequestLog.vue?vue&type=template&id=05897f96&"
import script from "./RequestLog.vue?vue&type=script&lang=js&"
export * from "./RequestLog.vue?vue&type=script&lang=js&"
import style0 from "./RequestLog.vue?vue&type=style&index=0&id=05897f96&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports